// extracted by mini-css-extract-plugin
module.exports = {"container":"I8v1FcFUGkSHmXf9cns2Y","groupsList":"_1LqMMkh-MeuX-TBpl0I2Lb"};